/**
 * /tenants/$slug/authentication/federation — External identity providers tab of the
 * Authentication hub. Thin route shim; domain logic lives in features/federation/.
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchFederationProviders, federationKeys } from "@/features/federation/queries";
import { FederationPage } from "@/features/federation/pages/federation-page";
import { federationSearchSchema } from "@/features/federation/schemas";

export const Route = createFileRoute("/_authed/tenants/$slug/authentication/federation")({
  validateSearch: (raw) => federationSearchSchema.parse(raw),
  loader: ({ context }) =>
    context.queryClient.ensureQueryData({
      queryKey: federationKeys.list(context.tenant.id),
      queryFn: () => fetchFederationProviders(context.tenant.id),
    }),
  component: FederationPage,
});
